import React from 'react';
import styles from './InputComponents.module.css';

const GroupInput = ({ question, data, onUpdate, renderQuestion, isSubmitted }) => {
    return (
        <div className={styles.groupWrapper}>
            <div className={styles.groupHeader}>
                <h3 className={styles.groupTitle}>{question.text}</h3>
            </div>
            <div className={styles.groupContent}>
                {question.questions?.map((subQuestion, index) => (
                    <div key={subQuestion.id} className={styles.groupQuestion}>
                        {renderQuestion(subQuestion, index)}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default GroupInput;